import React, { useState, useEffect } from "react";
import { Global } from "../helpers/Global";

export const RegistrarUsuarioMail = () => {
  const [managers, setManagers] = useState([]);
  const [mensaje, setMensaje] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombre: "",
    apellidos: "",
    dni: "",
    email: "",
    password: "",
    rol: "usuario",
    gerente_id: "",
    telefono: ""
  });

  // 🆕 archivo de avatar (opcional)
  const [avatarFile, setAvatarFile] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${Global.url}usuarios`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setManagers(data.filter((u) => u.rol === "gerente"));
        }
      } catch (err) {
        console.error("Error al obtener managers:", err);
      }
    })();
  }, []);

  const registrarUsuario = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setMensaje("");

    const payload = {
      ...nuevoUsuario,
      email: (nuevoUsuario.email || "").trim().toLowerCase(),
      dni: (nuevoUsuario.dni || "").toUpperCase().replace(/\s|-/g, "") || null,
      gerente_id: nuevoUsuario.gerente_id || null,
      telefono: nuevoUsuario.telefono?.trim() || null
    };

    try {
      const response = await fetch(`${Global.url}usuarios/admin/register-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setMensaje(`❌ ${data?.message || "Error al registrar el usuario."}`);
        return;
      }

      const createdUser = data.user;
      setMensaje("✅ Usuario registrado correctamente.");

      // 🖼️ Si hay avatar seleccionado, lo subimos ahora
      if (createdUser?.id && avatarFile) {
        try {
          const formData = new FormData();
          formData.append("avatar", avatarFile);

          const avatarRes = await fetch(`${Global.url}usuarios/${createdUser.id}/avatar`, {
            method: "POST",
            headers: {
              // ⚠️ Importante: NO poner "Content-Type": "application/json" aquí
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: formData,
          });

          const avatarData = await avatarRes.json().catch(() => ({}));
          if (!avatarRes.ok) {
            console.error("Error al subir avatar:", avatarData);
            setMensaje((prev) =>
              prev ? prev + " (avatar no subido)" : "Avatar no subido."
            );
          } else {
            setMensaje("✅ Usuario registrado y avatar subido correctamente.");
          }
        } catch (err) {
          console.error("Error de red al subir avatar:", err);
          setMensaje((prev) =>
            prev ? prev + " (error subiendo avatar)" : "Error subiendo avatar."
          );
        }
      }

      // Resetear formulario
      setNuevoUsuario({
        nombre: "",
        apellidos: "",
        dni: "",
        email: "",
        password: "",
        rol: "usuario",
        gerente_id: "",
        telefono: ""
      });
      setAvatarFile(null);

      setTimeout(() => setMensaje(""), 2500);
    } catch (error) {
      console.error("Error al registrar usuario:", error);
      setMensaje("❌ Error de conexión con el servidor.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // 🆕 handler cambio de archivo
  const onAvatarChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setAvatarFile(null);
      return;
    }
    if (!file.type.startsWith("image/")) {
      setMensaje("❌ El archivo seleccionado no es una imagen.");
      setAvatarFile(null);
      return;
    }
    if (file.size > 3 * 1024 * 1024) {
      setMensaje("❌ La imagen no puede superar los 3MB.");
      setAvatarFile(null);
      return;
    }
    setAvatarFile(file);
  };

  return (
    <div className="form-crear-usuario">
      <h2>Registrar Nuevo Usuario</h2>

      {mensaje && (
        <p className={`mensaje ${mensaje.includes("❌") ? "rojo" : "verde"}`}>{mensaje}</p>
      )}

      <form onSubmit={registrarUsuario} className="formulario-usuario">
        <div className="form-group">
          <label>Email (obligatorio):</label>
          <input
            type="email"
            value={nuevoUsuario.email}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, email: e.target.value })}
            required
            placeholder="usuario@dominio.com"
          />
        </div>

        <div className="form-group">
          <label>DNI (opcional):</label>
          <input
            type="text"
            value={nuevoUsuario.dni}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, dni: e.target.value })}
            placeholder="12345678Z"
          />
        </div>

        <div className="form-group">
          <label>Nombre:</label>
          <input
            type="text"
            value={nuevoUsuario.nombre}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, nombre: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Apellidos:</label>
          <input
            type="text"
            value={nuevoUsuario.apellidos}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, apellidos: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Teléfono (opcional):</label>
          <input
            type="text"
            value={nuevoUsuario.telefono}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, telefono: e.target.value })}
            placeholder="Ej: 600 123 456"
          />
        </div>

        {/* 🆕 Avatar (opcional) */}
        <div className="form-group">
          <label>Foto / Avatar (opcional):</label>
          <input
            type="file"
            accept="image/*"
            onChange={onAvatarChange}
          />
          {avatarFile && (
            <small className="muted">
              Seleccionado: {avatarFile.name} ({Math.round(avatarFile.size / 1024)} KB)
            </small>
          )}
        </div>

        <div className="form-group">
          <label>Contraseña:</label>
          <input
            type="password"
            value={nuevoUsuario.password}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, password: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Rol:</label>
          <select
            value={nuevoUsuario.rol}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, rol: e.target.value })}
            required
          >
            <option value="usuario">Usuario</option>
            <option value="gerente">Gerente</option>
            <option value="admin">Administrador</option>
          </select>
        </div>

        <div className="form-group">
          <label>Manager (opcional):</label>
          <select
            value={nuevoUsuario.gerente_id}
            onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, gerente_id: e.target.value })}
          >
            <option value="">Sin manager</option>
            {managers.map((g) => (
              <option key={g.id} value={g.id}>
                {g.nombre} {g.apellidos}
              </option>
            ))}
          </select>
        </div>

        <button className="btn-login" type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Registrando..." : "Registrar"}
        </button>
      </form>
    </div>
  );
};
